import api from "../api";

/**
 * Determines whether the user should go to
 * the Assessment or Dashboard.
 */
export const navigateToAssessmentOrDashboard = async (
  framework,
  navigate
) => {
  try {
    const endpoint =
      framework === "cobit"
        ? "maturity/analytics/cobit-dashboard/"
        : "maturity/analytics/bcm-dashboard/";

    const res = await api.get(endpoint);

    const assessments = Array.isArray(res.data.your_assessments)
      ? res.data.your_assessments
      : [];

    const hasActiveAssessment = assessments.some((assessment) => {
      const status = (
        assessment.status_label ||
        assessment.status ||
        ""
      ).toLowerCase();

      return !status.includes("submitted");
    });

    if (assessments.length === 0 || hasActiveAssessment) {
      navigate(`/${framework}/assessment`, {
        replace: true,
      });
    } else {
      navigate(`/${framework}/dashboard`, {
        replace: true,
      });
    }
  } catch (error) {
    console.error("Failed to determine assessment route:", error);

    // Safe fallback
    navigate(`/${framework}/assessment`, {
      replace: true,
    });
  }
};